import Glide from "@glidejs/glide";

class Carousel {
    constructor() {
        this.carousel = ".js-carousel";
    }

    setupCarousel() {
        const carousels = Array.from(document.querySelectorAll(this.carousel));

        carousels.forEach(carousel => {
            const glideCarousel = new Glide(carousel, {
                classes: {
                    direction: {
                        ltr: "carousel--ltr",
                        rtl: "carousel--rtl",
                    },
                    base: "carousel",
                    wrapper: "carousel__wrapper",
                    track: "carousel__track",
                    slide: "carousel__slide",
                    arrows: "carousel__arrows",
                    arrow: "carousel__arrow",
                    arrowNext: "next",
                    arrowPrev: "prev",
                    bullets: "carousel__bullets",
                    bullet: "carousel__bullet",
                    slider: "carousel__slider",
                    carousel: "carousel__carousel",
                    swipeable: "carousel--swipeable",
                    dragging: "carousel--dragging",
                    cloneSlide: "carousel__slide--clone",
                    activeNav: "carousel__bullet--active",
                    activeSlide: "carousel__slide--active",
                    disabledArrow: "carousel__arrow--disabled",
                },
            });

            // Automated height on Carousel build
            glideCarousel.on("build.after", function() {
                glideHandleHeight(carousel);
            });

            // Automated height on Carousel change
            glideCarousel.on("run.after", function() {
                glideHandleHeight(carousel);
            });

            // Mount!
            glideCarousel.mount();

            // Resize height
            function glideHandleHeight(carousel) {
                const activeSlide = carousel.querySelector(
                    ".glide__slide--active"
                );
                const activeSlideHeight = activeSlide
                    ? activeSlide.offsetHeight
                    : 0;

                const glideTrack = carousel.querySelector(".carousel__track");
                const glideTrackHeight = glideTrack
                    ? glideTrack.offsetHeight
                    : 0;

                if (activeSlideHeight !== glideTrackHeight) {
                    glideTrack.style.height = `${activeSlideHeight}px`;
                }
            }
        });
    }

    init() {
        this.setupCarousel();
    }
}

export default Carousel;



// WEBPACK FOOTER //
// ../project/craft/src/components/carousel/carousel.js